import { IcoLogo } from "~/icons";
import { Link, useLocation } from "@remix-run/react";
import { Button } from "~/components";
import { useEffect, useState, useCallback } from "react";
import { useWindowWidth } from "~/utils/hooks/useWindowWidth";
import { getFunnelURLWithTracking, useCrossDomainTracking } from "@tempt/ga4-cross-domain-tracking";

const Header = () => {
  const location = useLocation();
  const { pathname } = location;
  const width = useWindowWidth();
  const [isFixed, setIsFixed] = useState(false);
  const [opened, setOpened] = useState(false);
  const { crossDomainParams } = useCrossDomainTracking();
  
  const landingsURL = [
    "/promo",
    "/shereadsromancebooks",
    "/smartbitchestrashybooks",
  ];
  const isLandingPage = landingsURL.includes(pathname);

  const targetPath =
    pathname === "/about" || landingsURL.includes(pathname) ? pathname : "/";

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setOpened(false);
  }, [pathname]);

  const handleClickOnGetStarted = useCallback(() => {
    const isAboutPage = pathname === "/about";
    const baseFunnelURL = isAboutPage
      ? import.meta.env.VITE_ABOUT_FUNNEL_URL
      : import.meta.env.VITE_FUNNEL_URL;
    
    // Get funnel URL with cross-domain tracking parameters from context
    const funnelURL = getFunnelURLWithTracking(baseFunnelURL, crossDomainParams);
    
    setOpened(false);
    window.open(funnelURL, "_blank");
  }, [pathname, crossDomainParams]);

  return (
    <header
      className={`py-8 fixed top-0 w-full z-20 transition-all ease-linear duration-300 ${isFixed ? "bg-[#091227] py-4" : ""}`}
    >
      {opened && (
        <div className="bg-[#00000080] fixed left-0 top-0 w-full h-full backdrop-blur" />
      )}
      <div className="container">
        <div className="flex justify-between items-center">
          <Link to={targetPath}>
            <IcoLogo
              width={width && width > 768 ? 122 : 70}
              height={width && width > 768 ? 56 : 32}
            />
          </Link>
          <div className="flex items-center">
            {width && width < 768 && !isLandingPage ? (
              <div className="">
                <button
                  onClick={() => setOpened(!opened)}
                  className={`tham tham-e-squeeze tham-w-6 z-40 relative ${opened && "tham-active"}`}
                >
                  <div className="tham-box">
                    <div className="tham-inner bg-white" />
                  </div>
                </button>
                <ul
                  className={`${opened ? "bg-[#0D1E40] opacity-100 visible" : "opacity-0 invisible"} w-[180px] px-4 pb-6 transition-all duration-300 ease-linear absolute top-0 right-0 pt-[76px]`}
                >
                  <li>
                    {pathname === "/" ? (
                      <Link
                        className="text-white font-inter font-semibold text-xl leading-6 py-4 text-center w-full inline-block"
                        to="/about"
                      >
                        About Tempt
                      </Link>
                    ) : (
                      <Link
                        className="text-white font-inter font-semibold text-xl leading-6 py-4 text-center w-full inline-block"
                        to="/"
                      >
                        Catalog
                      </Link>
                    )}
                  </li>
                  <li>
                    <button
                      className="text-white font-inter font-semibold text-xl leading-6 py-4 text-center w-full inline-block"
                      onClick={handleClickOnGetStarted}
                    >
                      Get Started
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              <>
                {isLandingPage ? (
                  <Button className="max-md:hidden max-md:text-lg max-md:leading-5 min-w-max ml-5" />
                ) : (
                  <>
                    {pathname === "/" ? (
                      <Link
                        className="text-white font-inter font-semibold text-xl leading-6 py-4 text-center w-full inline-block"
                        to="/about"
                      >
                        About Tempt
                      </Link>
                    ) : (
                      <Link
                        className="text-white font-inter font-semibold text-xl leading-6 py-4 text-center w-full inline-block"
                        to="/"
                      >
                        Catalog
                      </Link>
                    )}
                    <Button className="max-md:text-lg max-md:leading-5 min-w-max ml-5" />
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

Header.displayName = "Header";

export default Header;
